import React, { useEffect } from 'react'
import Navbar from '../components/header/navbar'
import AboutHeader from '../components/about/AboutHeader'
import AboutBody from '../components/about/AboutBody'
import AOS from 'aos'

const AboutUs = () => {
  useEffect(() => {
    AOS.init({ once: true })
  }, [])

  return (
    <div className='max-w-7xl mx-auto'>
      <Navbar />

      <section className='px-4 py-8 lg:py-0'>
        <div>
          <AboutHeader />

          <AboutBody />
        </div>
      </section>
    </div>
  )
}

export default AboutUs
